var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [!_vm.isWeb ? _c('div', {
    staticClass: "top",
    style: {
      position: _vm.isWeb ? 'absolute' : 'fixed'
    },
    on: {
      "click": _vm.backClick
    }
  }, [_c('img', {
    attrs: {
      "src": "https://imagessl.edujia.com/A-1ed71af7_20230804162525.png",
      "crossorigin": "Anonymous"
    }
  }), _c('div', [_vm._v("返回")])]) : _vm._e(), _c('div', {
    staticClass: "psBar",
    style: {
      'padding-top': _vm.isWeb ? '0' : '84px'
    }
  }, [_c('div', [_vm._v("导入说明：")]), _c('div', [_vm._v(" 导入txt，话术分类和内容在一个文件里，"), _c('span', {
    on: {
      "click": _vm.modelLinkClick
    }
  }, [_vm._v("txt模板")])])]), _c('div', {
    staticClass: "actionBar"
  }, [_c('div', {
    staticClass: "actionBarL"
  }, [_vm._v(" 导入至"), _c('span', [_vm._v(_vm._s(_vm.teamName))])]), _vm.currentFile ? _c('div', {
    staticClass: "actionBarR actionBarRDisable"
  }, [_vm._v(" 选择文件 ")]) : _c('div', {
    staticClass: "actionBarR",
    on: {
      "click": _vm.fileChoose
    }
  }, [_vm._v(" 选择文件 ")])]), _c('div', {
    staticClass: "uploadArea"
  }, [!_vm.currentFile ? _c('div', {
    staticClass: "uploadAreaMain",
    on: {
      "click": _vm.fileChoose
    }
  }, [_c('img', {
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20240716140247.png"
    }
  }), _c('div', [_vm._v("点击选择文件")])]) : _c('div', {
    staticClass: "uploadAreaMain"
  }, [_c('img', {
    attrs: {
      "src": _vm.fileIcon
    }
  }), _c('div', [_vm._v(_vm._s(_vm.currentFile.name))])]), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "fileInput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChange
    }
  })]), _c('div', {
    staticClass: "btnBar"
  }, [_c('div', {
    staticClass: "btnBarL",
    on: {
      "click": _vm.backClick
    }
  }, [_vm._v(" 取消 ")]), _c('div', {
    staticClass: "btnBarR",
    on: {
      "click": _vm.importClick
    }
  }, [_vm._v(" 确定导入 ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };